import {Link} from 'react-router-dom';
import {ReactNode, useEffect} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useTrans} from '@common/i18n/use-trans';
import {Trans} from '@common/i18n/trans';
import './auth-layout.css';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}
export function AuthLayout({heading, children, message}: AuthPageProps) {
  const {trans} = useTrans();

  // Load fonts
  useEffect(() => {
    const id = 'auth-fonts';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.href =
        'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&family=DM+Sans:wght@300;400;500;600;700&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
  }, []);

  return (
    <main className="auth-page">
      <a
        href="/"
        onClick={e => {
          e.preventDefault();
          window.location.assign('/');
        }}
        className="auth-logo"
        aria-label={trans({message: 'Go to homepage'})}
      >
        <img
          src="/assets/images/logos/navbar-icon.png"
          alt=""
        />
      </a>

      <div className="auth-card">
        {heading && <h1>{heading}</h1>}
        {children}
      </div>
      {message && <div className="auth-message">{message}</div>}

      {/* Back to Home Button */}
      <a
        href="/"
        onClick={e => {
          e.preventDefault();
          window.location.assign('/');
        }}
        className="auth-back-btn"
      >
        <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        <Trans message="Back to Home" />
      </a>

      <AuthLayoutFooter />
    </main>
  );
}
